module.exports = __webpack_public_path__ + "img/google.0ff5d86.svg";